import * as yup from 'yup';

import TransactionPresenter from '../presenters/TransactionPresenter';
import { REQUIRED } from '../forms/errorsText.js';
import { emptyValueToEmptyString } from '../utils/values';

export const validationFields = {
  storeId: yup.string(),
  state: yup.string().required(REQUIRED),
  refundStatus: yup.string().nullable(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (transaction) => {
  const initialParams = {
    storeId: emptyValueToEmptyString(TransactionPresenter.storeId(transaction)),
    state: TransactionPresenter.state(transaction),
    refundStatus: TransactionPresenter.refundStatus(transaction),
  };

  return initialParams;
};
